import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useVerifiedStatus } from '../hooks/useVerifiedStatus';

export default function AppMenu({ isAdmin, isSuperadmin, isBjoechia, isMobile, onNavigate }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { verified } = useVerifiedStatus();
  const { t } = useTranslation('common');
  const isSalesTeam = user?.role === 'sales-team';

  const handleNavigate = (path) => {
    navigate(path);
    onNavigate?.();
  };

  const handleLogout = () => {
    logout();
    navigate('/');
    onNavigate?.();
  };

  if (isMobile) {
    return (
      <div className="flex flex-col divide-y divide-on-primary/10">
        <button
          onClick={() => handleNavigate('/dashboard')}
          className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
        >
          🏠 {t('nav.dashboard')}
        </button>

        {verified && (
          <button
            onClick={() => handleNavigate('/invite')}
            className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
          >
            📨 {t('nav.invite')}
          </button>
        )}

        <button
          onClick={() => handleNavigate('/genealogy')}
          className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
        >
          🌳 {t('nav.genealogy')}
        </button>

        {!isBjoechia && (
          <button
            onClick={() => handleNavigate('/members')}
            className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
          >
            👥 {t('nav.members')}
          </button>
        )}

        {!isBjoechia && (
          <button
            onClick={() => handleNavigate('/wallet')}
            className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
          >
            📦 {t('nav.packages')}
          </button>
        )}

        <button
          onClick={() => handleNavigate('/marketing-plan')}
          className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
        >
          📋 {t('nav.marketingPlan')}
        </button>

        <button
          onClick={() => handleNavigate('/guides')}
          className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
        >
          📖 {t('nav.guides')}
        </button>

        {isAdmin && (
          <>
            <button
              onClick={() => handleNavigate('/admin')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              ✓ {t('nav.approvals')}
            </button>

            <button
              onClick={() => handleNavigate('/admin-dashboard')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              📈 {t('nav.adminDashboard')}
            </button>

            <button
              onClick={() => handleNavigate('/admin-guide')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              📖 {t('nav.adminGuide')}
            </button>

            <button
              onClick={() => handleNavigate('/welcome-email')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              💌 {t('nav.welcomeEmail')}
            </button>

            {!isBjoechia && (
              <button
                onClick={() => handleNavigate('/member-rewards')}
                className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
              >
                🎁 {t('nav.memberRewards')}
              </button>
            )}

            <button
              onClick={() => handleNavigate('/sales-team')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              🧑‍💼 {t('nav.salesTeam')}
            </button>

            <button
              onClick={() => handleNavigate('/reports')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              📊 {t('nav.salesReports')}
            </button>

            <button
              onClick={() => handleNavigate('/rejected-sales')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              🚫 {t('nav.rejectedSales')}
            </button>

            <button
              onClick={() => handleNavigate('/balances')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              💰 {t('nav.balances')}
            </button>

            {!isBjoechia && (
              <button
                onClick={() => handleNavigate('/signup-wizard')}
                className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
              >
                🧙 {t('nav.signupWizard')}
              </button>
            )}

            <button
              onClick={() => handleNavigate('/rnr-credit-requests')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              🔄 {t('nav.rnrCreditRequests')}
            </button>

            <button
              onClick={() => handleNavigate('/settings')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              ⚙️ {t('nav.settings')}
            </button>
          </>
        )}

        {(isSalesTeam || isAdmin) && !isBjoechia && (
          <button
            onClick={() => handleNavigate('/signup-internal')}
            className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
          >
            📝 {t('nav.signupInternal')}
          </button>
        )}

        {isSalesTeam && !isAdmin && (
          <button
            onClick={() => handleNavigate('/rnr-credit-requests')}
            className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
          >
            🔄 {t('nav.rnrCreditRequests')}
          </button>
        )}

        {isSuperadmin && (
          <>
            <button
              onClick={() => handleNavigate('/ranking')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              ⭐ {t('nav.ranking')}
            </button>
            <button
              onClick={() => handleNavigate('/audit-logs')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              📜 {t('nav.auditLogs')}
            </button>
            <button
              onClick={() => handleNavigate('/admin-credit-topups')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              💳 {t('nav.creditTopups')}
            </button>
            <button
              onClick={() => handleNavigate('/archived')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              🗄️ {t('nav.archived')}
            </button>
            <button
              onClick={() => handleNavigate('/dev-dashboard')}
              className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
            >
              🛠️ {t('nav.devDashboard')}
            </button>
          </>
        )}

        <button
          onClick={() => handleNavigate('/edit-profile')}
          className="px-4 py-3 text-left text-on-primary hover:bg-on-primary/10 transition-colors"
        >
          👤 {t('nav.profile')}
        </button>

        <button
          onClick={handleLogout}
          className="px-4 py-3 text-left text-error hover:bg-error/10 transition-colors"
        >
          {t('nav.logout')}
        </button>
      </div>
    );
  }

  // Desktop dropdown menu (if needed)
  return (
    <div className="flex flex-col divide-y divide-outline">
      <button
        onClick={() => handleNavigate('/dashboard')}
        className="px-4 py-2 text-left text-on-surface hover:bg-primary/10 transition-colors"
      >
        {t('nav.dashboard')}
      </button>
      {verified && (
        <button
          onClick={() => handleNavigate('/invite')}
          className="px-4 py-2 text-left text-on-surface hover:bg-primary/10 transition-colors"
        >
          {t('nav.invite')}
        </button>
      )}
      <button
        onClick={() => handleNavigate('/edit-profile')}
        className="px-4 py-2 text-left text-on-surface hover:bg-primary/10 transition-colors"
      >
        {t('nav.profile')}
      </button>
      <button
        onClick={handleLogout}
        className="px-4 py-2 text-left text-error hover:bg-error/10 transition-colors"
      >
        {t('nav.logout')}
      </button>
    </div>
  );
}
